module.exports = __webpack_public_path__ + "0cedae913a3663ac5c2db64438c02329.MP3";